import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
    FicInput,
    FicTextArea,
    FicNumber,
} from "../../Utils/FormInputComponents/index";
import "../../../../../style/autoVentas/VentasForm.css";
import GenBtn from "../../components/GenBtn";
import { withRouter } from "react-router";
import LoadMask from "../../Utils/LoadMask/LoadMask";
import TablaPolizas from "./TablaPolizaVer";
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';

function VendedoresForm(props) {
    const { datosDeVenta, history, parametrosEmpresa, datos } = props;

    const urlParams = props.match.params;
    const empresa = urlParams.empresa;
    const ventaId = urlParams.ventaId;
    const [loadingState, setLoadingState] = useState(true);
    const [poliza, setPoliza] = useState([]);
    const [key, setKey] = useState('VENTA_TAB');
    
    const {
        control,
        formState: {  },
    } = useForm({
        mode: "all",
        defaultValues: async () => {
            const formData = await datosDeVenta(ventaId);
            parametrosEmpresa();
            setLoadingState(false);
            setPoliza(formData.poliza)
            return formData;
        },
    });
    
    return (
        <React.Fragment>
            <br />
            <div className="py-1">
                <div className="mb-1">
                    <div className="p-0 px-3 pt-0">
                    {(datos.contabilidad === 'S') &&
                        <form
                            encType="multipart/form-data" 
                            onSubmit={() => {}}
                        >
                            <Tabs
                                destroyInactiveTabPane={true}
                                activeKey={key}
                                onChange={(k) => setKey(k)}
                                defaultActiveKey="PRINCIPAL_TOP"
                                tabBarPosition="top"
                                renderTabBar={() => <ScrollableInkTabBar />}
                                renderTabContent={() => <TabContent />}
                            >
                                <TabPane tab="Venta" key="VENTA_TAB">
                                    <div className="py-2 px-3">
                                        <div className="mb-4 text-white mb-1">
                                            <div className="p-0 pt-4 d-flex flex-column flex-md-row">
                                                <div className="d-flex flex-column flex-1 mx-4">
                                                    <h3
                                                        className="p-2  title rounded shadow"
                                                        style={{
                                                            background:
                                                                "linear-gradient(to top right, #790021, #2d2d2d)",
                                                        }}
                                                    >
                                                        Ver Venta
                                                    </h3>
                                                    <br />
                                                    <div className="d-flex flex-row justify-content-start mb-2">
                                                        <GenBtn
                                                            BtnColor="#787878"
                                                            style={{ width: "100px", height: "40px" }}
                                                            onPress={(e) => {
                                                                history.push(`/auto_ventas/${empresa}/ventas`);
                                                            }}
                                                        >
                                                            Regresar
                                                        </GenBtn>
                                                    </div>
                                                    <LoadMask loading={loadingState} color="#bd0034" blur={true}>
                                                        <form encType="multipart/form-data" onSubmit={() => {}}>
                                                            <div style={{ color: "white" }}>DATOS DEL VEHICULO</div>
                                                            <div className="ventas-form__auto-data">
                                                                <div className="ventas-form__inputs-container">
                                                                    <FicInput
                                                                        label="Placa"
                                                                        name="placa"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Codigo"
                                                                        name="codigo"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Tipo de carro"
                                                                        name="tipo_carro"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Modelo"
                                                                        name="modelo"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Linea"
                                                                        name="linea"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />

                                                                    <FicInput
                                                                        label="Numero de serie"
                                                                        name="num_serie"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Modalidad"
                                                                        name="modalidad"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <FicInput
                                                                componentStyle={{
                                                                    marginTop: "15px",
                                                                    marginBottom: "15px",
                                                                }}
                                                                control={control}
                                                                name="carro"
                                                                label="Carro"
                                                                isDisabled={true}
                                                            />

                                                            <div className="ventas-form__form-container">
                                                                <div style={{ color: "white" }}>
                                                                    DATOS DE LA VENTA
                                                                </div>
                                                                <div className="ventas-form__inputs-container">
                                                                    <FicInput
                                                                        control={control}
                                                                        name="fecha_venta"
                                                                        label="Fecha"
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        control={control}
                                                                        name="vendedor"
                                                                        label="Vendedor"
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Comprador"
                                                                        name="comprador_nombre"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Numero de DPI"
                                                                        name="comprador_dpi"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Domicilio fiscal"
                                                                        name="comprador_domicilio"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Departamento"
                                                                        name="comprador_departamento"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Profesion u oficio"
                                                                        name="comprador_profesion"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Numero de Telefono"
                                                                        name="comprador_num_telefono"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="NIT"
                                                                        name="comprador_nit"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Edad"
                                                                        name="comprador_edad"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicInput
                                                                        label="Estado civil"
                                                                        name="comprador_estado_civil"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicNumber
                                                                        formatOptions={{
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2,
                                                                        }}
                                                                        label="Valor de venta"
                                                                        name="valor_venta"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                    />
                                                                    <FicTextArea
                                                                        label="Observaciones"
                                                                        name="observaciones"
                                                                        control={control}
                                                                        isDisabled={true}
                                                                        style={{
                                                                            minHeight: "36.7px",
                                                                            gridColumn: "1/-1",
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </LoadMask>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPane>
                                <TabPane tab="Póliza" key="POLIZA_TAB">
                                    <div className="py-2 px-3">
                                        <div className="mb-4 mb-3">
                                            <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                                                <div className="d-flex flex-column flex-1 mx-3">
                                                    <TablaPolizas
                                                        datos={poliza} 
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPane>            
                            </Tabs>
                        </form>
                    }
                    {(datos.contabilidad === 'N') &&
                        <form
                            encType="multipart/form-data" 
                            onSubmit={() => {}}
                        >
                            <h3
                                className="p-2  title rounded shadow"
                                style={{
                                    background:
                                        "linear-gradient(to top right, #790021, #2d2d2d)",
                                }}
                            >
                                Ver Venta
                            </h3>
                            <br />
                            <div className="d-flex flex-row justify-content-start mb-2">
                                <GenBtn
                                    BtnColor="#787878"
                                    style={{ width: "100px", height: "40px" }}
                                    onPress={(e) => {
                                        history.push(`/auto_ventas/${empresa}/ventas`);
                                    }}
                                >
                                    Regresar
                                </GenBtn>
                            </div>
                            <LoadMask loading={loadingState} color="#bd0034" blur={true}>
                                <form encType="multipart/form-data" onSubmit={() => {}}>
                                    <div style={{ color: "white" }}>DATOS DEL VEHICULO</div>
                                    <div className="ventas-form__auto-data">
                                        <div className="ventas-form__inputs-container">
                                            <FicInput
                                                label="Placa"
                                                name="placa"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Codigo"
                                                name="codigo"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Tipo de carro"
                                                name="tipo_carro"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Modelo"
                                                name="modelo"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Linea"
                                                name="linea"
                                                control={control}
                                                isDisabled={true}
                                            />

                                            <FicInput
                                                label="Numero de serie"
                                                name="num_serie"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Modalidad"
                                                name="modalidad"
                                                control={control}
                                                isDisabled={true}
                                            />
                                        </div>
                                    </div>

                                    <FicInput
                                        componentStyle={{
                                            marginTop: "15px",
                                            marginBottom: "15px",
                                        }}
                                        control={control}
                                        name="carro"
                                        label="Carro"
                                        isDisabled={true}
                                    />

                                    <div className="ventas-form__form-container">
                                        <div style={{ color: "white" }}>
                                            DATOS DE LA VENTA
                                        </div>
                                        <div className="ventas-form__inputs-container">
                                            <FicInput
                                                control={control}
                                                name="fecha_venta"
                                                label="Fecha"
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                control={control}
                                                name="vendedor"
                                                label="Vendedor"
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Comprador"
                                                name="comprador_nombre"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Numero de DPI"
                                                name="comprador_dpi"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Domicilio fiscal"
                                                name="comprador_domicilio"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Departamento"
                                                name="comprador_departamento"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Profesion u oficio"
                                                name="comprador_profesion"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Numero de Telefono"
                                                name="comprador_num_telefono"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="NIT"
                                                name="comprador_nit"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Edad"
                                                name="comprador_edad"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicInput
                                                label="Estado civil"
                                                name="comprador_estado_civil"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicNumber
                                                formatOptions={{
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                }}
                                                label="Valor de venta"
                                                name="valor_venta"
                                                control={control}
                                                isDisabled={true}
                                            />
                                            <FicTextArea
                                                label="Observaciones"
                                                name="observaciones"
                                                control={control}
                                                isDisabled={true}
                                                style={{
                                                    minHeight: "36.7px",
                                                    gridColumn: "1/-1",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </LoadMask>
                        </form>
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withRouter(VendedoresForm);
